import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { Login } from './components/Login';
import { Register } from './components/Register';
import { Fields } from './components/Fields';
import { Field } from './components/Field';
import ChatAssistant from './components/ChatAssistant';
import { CreateField } from './components/CreateField';
import { EditField } from './components/EditField';
import { UpdateUser } from './components/UpdateUser';
import { PrivateRoute } from './components/PrivateRoute';
import { PrimeReactProvider } from 'primereact/api';
import 'primeflex/primeflex.css';
import 'primereact/resources/themes/saga-green/theme.css';
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import "@assistant-ui/react-ui/styles/index.css";

import { ModalNetwork } from './components/ModalNetwork';

function App() {
  const [isNetworkModalOpen, setIsNetworkModalOpen] = useState(!navigator.onLine);

  const isAuthenticated = () => {
    return !!localStorage.getItem('accessToken') && !!localStorage.getItem('refreshToken');
  };

  useEffect(() => {
    const handleOnline = () => setIsNetworkModalOpen(false);
    const handleOffline = () => setIsNetworkModalOpen(true);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <>
      <Router>
        <PrimeReactProvider>
          <ModalNetwork
            isOpen={isNetworkModalOpen}
            message={"No internet connection. Please check your network settings."}
            onClose={() => setIsNetworkModalOpen(false)}
            onConfirm={() => setIsNetworkModalOpen(false)} />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/fields" element={<PrivateRoute element={Fields} />} />
            <Route path="/field/:id" element={<PrivateRoute element={Field} />} />
            <Route path="/field/:id/edit" element={<PrivateRoute element={EditField} />} />
            <Route path="/createField" element={<PrivateRoute element={CreateField} />} />
            <Route path="/chatAssistant" element={<PrivateRoute element={ChatAssistant} />} />
            <Route path="/updateUser" element={<PrivateRoute element={UpdateUser} />} />
            <Route path="*" element={isAuthenticated() ? <Navigate to="/fields" replace /> : <Navigate to="/login" replace />} />
          </Routes>
        </PrimeReactProvider>
      </Router>
    </>
  );
}

export default App;
